export const API_LIVE_CONTENT_URL = 'https://api.getblueshift.com/live';
export const COOKIE_NAME = '_bs';
export const PUBLIC_API_KEY = '65ac92a8faa38d92eb82353a532b8d9c';
export enum SlotNames {
  TopBanner = 'TopBanner',
  NewFeature = 'NewFeature',
  PopUp = 'PopUp',
}
